if (!customElements.get("variant-selects")) {
  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      // 读取 data-sticky 属性，判断是否为粘性模式
      this.sticky = this.dataset.sticky;
      // 读取 data-update-url 属性，判断是否需要更新 URL
      this.updateUrl = this.dataset.updateUrl === "true";
      // 读取 data-is-disabled 属性，判断是否禁用某些功能
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener("change", this.onVariantChange);
      this.other = Array.from(
        document.querySelectorAll("variant-selects")
      ).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest(".thb-product-detail");
      this.customVariants = this.closest(".product-information").querySelector(
        "custom-variants"
      );
      this.productSlider = this.productWrapper.querySelector(".product-images");
      this.hideVariants = this.dataset.hideVariants === "true";
     
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
    }

    onVariantChange() {
      console.log("切换变体");
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(false, "", false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        console.log("切换变体", this.currentVariant);
        this.toggleAddButton(true, "", true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        // 判断当前页面是否存在 custom-variants 元素，如果存在则执行相关事件
        if (this.customVariants) {
          console.log("custom-product-variants 元素已存在");
          this.updateCustomProductVariants();
        } else {
          console.log("custom-product-variants 元素不存在");
        }
        //this.updateShareUrl();
      }

      this.updateOther();
      dispatchCustomEvent("product:variant-change", {
        variant: this.currentVariant,
        sectionId: this.dataset.section,
      });
    }
    updateCustomProductVariants() {
      // 获取 <html> 元素的 data-country 属性，当为 US 时执行
      // const htmlCountry = document.documentElement.getAttribute("data-country");
      let format = theme.settings.money_with_currency_format;
      // 如果 this.format 包含 <span class="money"></span>，则提取 > 和 < 之间的内容作为格式
      const moneySpanMatch = format.match(
        /<span\s+class=["']money["']>(.*?)<\/span>/i
      );
      if (moneySpanMatch) {
        format = moneySpanMatch[1];
      }
      // if (htmlCountry === "US") {
      //   // 这里编写当国家为 US 时需要执行的代码
      //   console.log("当前国家为美国，执行相关逻辑");
      //   // 你可以在这里添加更多需要执行的操作
      //   format = "${{amount}}";
      // }

      const activeCustomVariant = this.customVariants.querySelector(
        ".js-custom-variant.active"
      );
      const productInfoEl = this.closest(".product-information").querySelector(
        ".product-information--inner"
      );
      // 判断当前 productInfoEl 是否包含 class showActivityPrice
      const hasShowActivityPrice =
        productInfoEl && productInfoEl.classList.contains("showActivityPrice");

      if (hasShowActivityPrice) {
        console.log('当前已经设置折扣')
        this.currentAutomaticDiscountVariantData =
          this.getAutomaticDiscountVariantData().find(
            (variant) => variant.id === this.currentVariant.id
          );
        const $reminder = this.closest(".product-information").querySelector(
          "custom-automatic-discount-reminder"
        );
        console.log(
          "自定义属性切换模块对应变体",
          this.currentAutomaticDiscountVariantData
        );

        setTimeout(() => {
          const $finalPrice = $reminder.querySelector("[data-final-price]");
          let moneyValue = "";
          let moneyEl = $finalPrice.querySelector(".money");
          if (moneyEl) {
            moneyValue = moneyEl.textContent;
          } else {
            moneyValue = $finalPrice.textContent.replace(":", "");
          }
          console.log("自定义属性切换模块对应的销售价格", moneyValue);
          let productPriceMoneyEl = activeCustomVariant.querySelector(
            ".custom-product-price .money"
          );
          if (productPriceMoneyEl) {
            productPriceMoneyEl.textContent = moneyValue;
          } else {
            activeCustomVariant.querySelector(
              ".custom-product-price"
            ).textContent = moneyValue;
          }
        }, 100);

        activeCustomVariant.querySelector(
          ".custom-product-price-compare"
        ).innerHTML = window.formatMoney(
          this.currentAutomaticDiscountVariantData.price,
          format
        );
      } else {
        console.log('当前没有设置折扣')
        console.log("this.getVariantData()", this.getVariantData());
        const price = this.currentVariant.price;
        const compare_at_price = this.currentVariant.compare_at_price;
        console.log("自定义产品选择器当前变体原价=", compare_at_price);
        console.log("自定义产品选择器当前变体售价=", price);
        if (compare_at_price > price) { 
          activeCustomVariant.querySelector(".custom-product-price-compare").style.display = "block";
          activeCustomVariant.querySelector(
            ".custom-product-price-compare"
          ).innerHTML = window.formatMoney(compare_at_price, format);
        }else{
          activeCustomVariant.querySelector(".custom-product-price-compare").style.display = "none";
        }
        
        
        activeCustomVariant.querySelector(".custom-product-price").innerHTML =
          window.formatMoney(price, format);
      }
    }
    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector("select")) {
          this.options.push(fieldset.querySelector("select").value);
        } else if (fieldset.querySelectorAll("input").length) {
          this.options.push(fieldset.querySelector("input:checked").value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector(".form__label__value");
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === "false") {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll("fieldset"),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector("select")) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll("input").length) {
            fieldsets_array[i].querySelector(
              `input[value='${option}']`
            ).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let productSlider = document.querySelector(
          ".thb-product-detail .product-images"
        ),
        thumbnails = document.querySelector(
          ".thb-product-detail #Product-Thumbnails"
        );

      this.setActiveMedia(
        `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        productSlider,
        thumbnails
      );
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      // 用能力检测代替原来的 Flickity.data(productSlider)。
      // selectCell / reInit 是原型方法，元素没接管时也存在，
      // 所以必须同时看 isReady（connectedCallback 找到 track 后才会置 true）。
      const sliderReady =
          productSlider &&
          productSlider.isReady === true &&
          typeof productSlider.selectCell === "function" &&
          typeof productSlider.reInit === "function",
        activeMedia = productSlider
          ? productSlider.querySelector(mediaId)
          : null;

      this.syncVariantMedia(productSlider, thumbnails, activeMedia, thumbId);

      if (sliderReady && this.hideVariants) {
        if (
          productSlider.querySelector(
            ".product-images__slide.is-initial-selected"
          )
        ) {
          productSlider
            .querySelector(".product-images__slide.is-initial-selected")
            .classList.remove("is-initial-selected");
        }
        [].forEach.call(
          productSlider.querySelectorAll(
            ".product-images__slide-item--variant"
          ),
          function (el) {
            el.classList.remove("is-active");
          }
        );

        if (activeMedia) {
          activeMedia.classList.add("is-active");
          activeMedia.classList.add("is-initial-selected");
        }

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          if (
            thumbnails.querySelector(".product-thumbnail.is-initial-selected")
          ) {
            thumbnails
              .querySelector(".product-thumbnail.is-initial-selected")
              .classList.remove("is-initial-selected");
          }
          [].forEach.call(
            thumbnails.querySelectorAll(".product-images__slide-item--variant"),
            function (el) {
              el.classList.remove("is-active");
            }
          );

          if (activeThumb) {
            activeThumb.classList.add("is-active");
            activeThumb.classList.add("is-initial-selected");
          }
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId, true);
      } else if (sliderReady) {
        productSlider.selectCell(mediaId, true);
      }
    }

    syncVariantMedia(productSlider, thumbnails, activeMedia, thumbId) {
      if (!productSlider) return;
      const variantSlides = productSlider.querySelectorAll(
        ".product-images__slide-item--variant"
      );
      const variantThumbs = thumbnails
        ? thumbnails.querySelectorAll(".product-images__slide-item--variant")
        : [];
      if (!variantSlides.length && !variantThumbs.length) return;
      if (!activeMedia) return;

      const activeThumb = thumbnails ? thumbnails.querySelector(thumbId) : null;

      variantSlides.forEach((el) => el.classList.remove("is-current-variant"));
      variantThumbs.forEach((el) => el.classList.remove("is-current-variant"));
      activeMedia.classList.add("is-current-variant");
      if (activeThumb) activeThumb.classList.add("is-current-variant");

      if (productSlider.dataset.variantFirst !== "true") return;

      const track = activeMedia.parentElement;
      const moved =
        track && track.firstElementChild !== activeMedia
          ? (track.insertBefore(activeMedia, track.firstElementChild), true)
          : false;

      if (activeThumb && activeThumb.parentElement) {
        const thumbParent = activeThumb.parentElement;
        if (thumbParent.firstElementChild !== activeThumb) {
          thumbParent.insertBefore(activeThumb, thumbParent.firstElementChild);
        }
      }

      if (moved) {
        if (typeof productSlider.reInit === "function") productSlider.reInit();
        const zoomLink = activeMedia.querySelector(".product-single__media-zoom");
        if (zoomLink && "zoomObjectOffset" in zoomLink) {
          zoomLink.zoomObjectOffset = 0;
        }
        activeMedia.querySelectorAll("img.lazyload[data-src]").forEach((img) => {
          if (typeof productSlider._unveil === "function") {
            productSlider._unveil(img);
          } else if (img.dataset.src && !img.getAttribute("src")) {
            img.src = img.dataset.src;
          }
        });
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }

    updateShareUrl() {
      const shareButton = document.getElementById(
        `Share-${this.dataset.section}`
      );
      if (!shareButton) return;
      shareButton.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(
          new Event("change", {
            bubbles: true,
          })
        );
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector(
        ".pickup-availability-wrapper"
      );

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }

    removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;

      const productForm = section.querySelector("product-form");
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [
        `price-${this.dataset.section}`,
        `price-${this.dataset.section}--sticky`,
        `product-image-${this.dataset.section}--sticky`,
        `inventory-${this.dataset.section}`,
        `sku-${this.dataset.section}`,
        `quantity-${this.dataset.section}`,
      ];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + "--sticky");

            if (price) price.classList.remove("visibility-hidden");
            if (price_fixed) price_fixed.classList.remove("visibility-hidden");
          });
          console.log(
            ".product-information==",
            this.closest(".product-information")
          );
          console.log(
            ".product-information>.product-information--inner==",
            this.closest(".product-information").querySelector(
              ".product-information--inner"
            )
          );
          console.log(
            "this.getAutomaticDiscountVariantData()==",
            this.getAutomaticDiscountVariantData()
          );
          const productInfoEl = this.closest(
            ".product-information"
          ).querySelector(".product-information--inner");
          const hasShowActivityPrice =
            productInfoEl &&
            productInfoEl.classList.contains("showActivityPrice");

          console.log("hasShowActivityPrice ===", hasShowActivityPrice);
          if (hasShowActivityPrice) {
            this.currentAutomaticDiscountVariantData =
              this.getAutomaticDiscountVariantData().find(
                (variant) => variant.id === this.currentVariant.id
              );
            console.log(
              "this.currentAutomaticDiscountVariantData ===",
              this.currentAutomaticDiscountVariantData
            );
            if (
              this.currentAutomaticDiscountVariantData &&
              this.currentAutomaticDiscountVariantData.custom_discount &&
              this.currentAutomaticDiscountVariantData.custom_discount !== 0
            ) {

              if (productInfoEl) {
                var activityPriceEls = productInfoEl.querySelectorAll(
                  ".activity-price-display"
                );
                activityPriceEls.forEach(function (el) {
                  el.style.display = "block";
                  el.classList.add("show");
                });
                productInfoEl.classList.add("showActivityPrice");
                var dailyPriceEls = productInfoEl.querySelectorAll(
                  ".daily-price-display"
                );
                dailyPriceEls.forEach(function (el) {
                  el.style.display = "none";
                });
              }
              const $reminder = this.closest(
                ".product-information"
              ).querySelector("custom-automatic-discount-reminder");
              const $finalPrice = $reminder.querySelector("[data-final-price]");
              let moneyValue = "";
              let moneyEl = $finalPrice.querySelector(".money");
              if (moneyEl) {
                moneyValue = moneyEl.textContent;
              } else {
                moneyValue = $finalPrice.textContent.replace(":", "");
              }
              $finalPrice.style.display = "none";
              console.log(
                "custom-automatic-discount-reminder 下 data-final-price 的 .money 值:",
                moneyValue
              );

              const $productCardPriceAndButton = this.closest(
                ".product-information"
              ).querySelector(".product-price-container");
              const $productAddToCartSticky = document.querySelector(
                "product-add-to-cart-sticky"
              );
              const insMoneyEl =
                $productCardPriceAndButton.querySelector("ins .money");
              const delMoneyEl =
                $productCardPriceAndButton.querySelector(".del .money");
              const $stickyProduct =
                $productAddToCartSticky.querySelector(".product-price ");
              const $stickyProductActivityPrice = $stickyProduct.querySelector(
                ".activity-price-display"
              );
              const $stickyProductDailyPrice = $stickyProduct.querySelector(
                ".daily-price-display"
              );
              $stickyProductActivityPrice.style.display = "block";
              $stickyProductDailyPrice.style.display = "none";

              this.currency_code_enabled = theme.settings.currency_code_enabled
              if(this.currency_code_enabled){
                this.format = theme.settings.money_with_currency_format;
              }else{
                this.format = theme.settings.money_format;
              }
             
              const moneySpanMatch = this.format.match(
                /<span\s+class=["']money["']>(.*?)<\/span>/i
              );
              if (moneySpanMatch) {
                this.format = moneySpanMatch[1];
              }

              if (!moneyValue || !String(moneyValue).trim()) {
                moneyValue = window.formatMoney(
                  this.currentVariant.price,
                  this.format
                );
              }
              if (insMoneyEl) {
                insMoneyEl.textContent = moneyValue;
                const stickyInsMoneyEl =
                  $stickyProductActivityPrice.querySelector("ins .money");
                if (stickyInsMoneyEl) {
                  stickyInsMoneyEl.textContent = moneyValue;
                }
              }
              if (delMoneyEl) {
                delMoneyEl.textContent = window.formatMoney(
                  this.currentAutomaticDiscountVariantData.price,
                  this.format
                );
              }
            }
          }

          this.toggleAddButton(
            !this.currentVariant.available,
            window.theme.variantStrings.soldOut
          );
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(
        `product-form-${this.dataset.section}`
      );
      if (!productForm) return;

      const submitButtons = document.querySelectorAll(
        ".single-add-to-cart-button"
      );

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          ".single-add-to-cart-button--text"
        );

        if (!submitButtonText) return;
        if (this.currentVariant.selling_plan_allocations.length == 0) {
          if (disable) {
            submitButton.setAttribute("disabled", "disabled");
            // submitButton.style.opacity = "0";
            if (text) submitButtonText.textContent = text;
          } else {
            submitButton.removeAttribute("disabled");
            // submitButton.style.opacity = "1";
            submitButton.classList.remove("loading");
            submitButtonText.textContent =
              window.theme.variantStrings.addToCart;
          }
        } else {
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll(
        ".single-add-to-cart-button"
      );
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(
        `price-${this.dataset.section}--sticky`
      );

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          ".single-add-to-cart-button--text"
        );
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add("sold-out");
      });
      if (price) price.classList.add("visibility-hidden");
      if (price_fixed) price_fixed.classList.add("visibility-hidden");
    }

    setDisabled() {
      if (this.isDisabledFeature != "true") {
        return;
      }
      const variant_data = this.getVariantData();

      if (variant_data) {
        const selected_options = this.currentVariant.options.map(
          (value, index) => {
            return {
              value,
              index: `option${index + 1}`,
            };
          }
        );
        const available_options = this.createAvailableOptionsTree(
          variant_data,
          selected_options
        );

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector("select")) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]"
                  ).disabled = true;
                } else {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]"
                  ).disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll("input").length) {
              fieldset.querySelectorAll("input").forEach((input, input_i) => {
                input.classList.toggle(
                  "is-disabled",
                  fieldset_options[input_i].isUnavailable
                );
              });
            }
          }
        });
      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "");
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector("[data-set-name]");
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector(
          '.product-form__input[data-handle="' + this.imageSetName + '"]'
        ).dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(
        this.currentVariant[this.imageSetIndex]
      );
      let group = this.imageSetName + "_" + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(
          `.product-images__slide[data-set-name="${this.imageSetName}"]`
        ),
        selected_set_thumbs = this.productWrapper.querySelectorAll(
          `.product-thumbnail[data-set-name="${this.imageSetName}"]`
        );

      if (this.hideVariants) {
        // Product images
        this.productWrapper
          .querySelectorAll(".product-images__slide")
          .forEach((thumb) => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove("is-active");
            }
          });
        selected_set_images.forEach((thumb) => {
          thumb.classList.toggle("is-active", thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper
          .querySelectorAll(".product-thumbnail")
          .forEach((thumb) => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove("is-active");
            }
          });
        selected_set_thumbs.forEach((thumb) => {
          thumb.classList.toggle("is-active", thumb.dataset.group === group);
        });
      }
    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce(
        (options, variant) => {
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach((index) => {
            if (variant[index] === null) return;

            let entry = options[index].find(
              (option) => option.value === variant[index]
            );

            if (typeof entry === "undefined") {
              // If option has yet to be added to the options tree, add it
              entry = {
                value: variant[index],
                isUnavailable: true,
              };
              options[index].push(entry);
            }

            // Check how many selected option values match a variant
            const countVariantOptionsThatMatchCurrent = selected_options.reduce(
              (count, { value, index }) => {
                return variant[index] === value ? count + 1 : count;
              },
              0
            );

            // Only enable an option if an available variant matches all but one current selected value
            if (
              countVariantOptionsThatMatchCurrent >=
              selected_options.length - 1
            ) {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }

            // Make sure if a variant is unavailable, disable currently selected option
            if (
              (!this.currentVariant || !this.currentVariant.available) &&
              selected_options.find(
                (option) =>
                  option.value === entry.value && index === option.index
              )
            ) {
              entry.isUnavailable = true;
            }

            // First option is always enabled
            if (index === "option1") {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }
          });

          return options;
        },
        {
          option1: [],
          option2: [],
          option3: [],
        }
      );
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    getAutomaticDiscountVariantData() {
      const automaticDiscountVariantDataEl = this.closest(
        ".product-information"
      ).querySelector("custom-automatic-discount-reminder");
      this.automaticDiscountVariantData =
        this.automaticDiscountVariantData ||
        JSON.parse(
          automaticDiscountVariantDataEl.querySelector(
            '[type="application/json"]'
          ).textContent
        );
      return this.automaticDiscountVariantData;
    }
  }
  customElements.define("variant-selects", VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      });
    }
  }

  customElements.define("variant-radios", VariantRadios);
}
if (!customElements.get("custom-automatic-discount-reminder")) {
  /**
   *  @class
   *  @function AutomaticDiscountReminder  自动折扣提醒
   */
  class AutomaticDiscountReminder extends window.HTMLElement {
    constructor() {
      super();
      // 获取 <html> 元素的 data-country 属性，当为 US 时执行
      // const htmlCountry = document.documentElement.getAttribute("data-country");
      this.currency_code_enabled = theme.settings.currency_code_enabled
      if(this.currency_code_enabled){
        this.format = theme.settings.money_with_currency_format;
      }else{
        this.format = theme.settings.money_format;
      }
      
      
      // 如果 this.format 包含 <span class="money"></span>，则提取 > 和 < 之间的内容作为格式
      const moneySpanMatch = this.format.match(
        /<span\s+class=["']money["']>(.*?)<\/span>/i
      );
      if (moneySpanMatch) {
        this.format = moneySpanMatch[1];
      }
      // if (htmlCountry === "US") {
      //   // 这里编写当国家为 US 时需要执行的代码
      //   console.log("当前国家为美国，执行相关逻辑");
      //   // 你可以在这里添加更多需要执行的操作
      //   this.format = "${{amount}}";
      // }

      console.log("货币单位", this.format);
      console.log("包含货币", this.currency_code_enabled);
    }

    connectedCallback() {
      this.variantData = this.getVariantData();
      this.finalSalePriceEl = this.querySelector("[data-final-sale-price]");
      this.finalPriceEl = this.querySelector("[data-final-price]");
      this.bindEvents();
    }

    getVariantData() {
      if (this.variantData) return this.variantData;
      const jsonElement = this.querySelector('[type="application/json"]');
      if (!jsonElement) throw new Error("JSON data element not found");
      return (this.variantData = JSON.parse(jsonElement.textContent));
    }

    findSelectVariant(variantId) {
      return this.variantData.find((variant) => variant.id === variantId);
    }

    bindEvents() {
      document.addEventListener("product:variant-change", ({ detail }) => {
        const { variant } = detail;
        const selectedVariant = this.findSelectVariant(variant.id);
        const customDiscount = selectedVariant?.custom_discount;

        if (this.classList.toggle("hidden", !customDiscount) && !customDiscount)
          // 隐藏元素
          return;
        // console.log('customDiscount===',customDiscount);
        if (customDiscount == 0) {
          this.classList.toggle("hidden", true);
        }

        let discountAmount = 0;
        let finalPrice = selectedVariant.price;

        if (customDiscount.includes("%")) {
          const discountPercentage = parseFloat(customDiscount.split("%")[0]);
          discountAmount = (selectedVariant.price * discountPercentage) / 100;
        } else {
          discountAmount = parseFloat(customDiscount);
        }

        finalPrice -= discountAmount;

        this.finalPriceEl.innerHTML = window.formatMoney(
          finalPrice,
          this.format
        );
        this.finalSalePriceEl.innerHTML = `-${window.formatMoney(
          discountAmount,
          this.format
        )}`;
      });
    }
  }

  window.customElements.define(
    "custom-automatic-discount-reminder",
    AutomaticDiscountReminder
  );
}


if (!customElements.get("product-slider")) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.selectedIndex = 0;
      this._syncedIndex = 0;
      this.isReady = false;
      // 程序化平滑滚动期间为 true，抑制计数跟随（见 _goTo / _onScroll）
      this._suppressCounter = false;
      this._activeThumb = null;
      this._raf = 0;
      this._settleTimer = 0;
      this._eventsBound = false;
      this._cachedVisibleSlides = null;

      this._onScroll = this._onScroll.bind(this);
      this._onScrollEnd = this._onScrollEnd.bind(this);

      // 媒体集合变化后重新对齐（幂等）
      this.addEventListener("change", () => this.reInit());
    }

    connectedCallback() {
      if (this._connected) return;
      this._connected = true;

      this.product_container = this.closest(".thb-product-detail");
      this.track = this.querySelector(".product-images__track");

      // 缩略图容器是本图库内的兄弟节点。必须限定在当前 .product-image-container，
      // 否则详情页三个图库（Packages/Features/Video）会全部取到第一个的缩略图容器，
      // 互相把对方的选中态清掉。
      const gallery = this.closest(".product-image-container");
      this.thumbnail_container = gallery
        ? gallery.querySelector(".product-thumbnail-container")
        : this.product_container
        ? this.product_container.querySelector(".product-thumbnail-container")
        : null;

      // 没有 track 就地创建一个再接管。
      // main-product-l1800 的 track 写在 markup 里（首屏必须不依赖 JS）；
      // 其余几个 section 保持原样不动，由这里把直接子级的 slides 包起来，
      // 避免为了一个 div 去改 3 个 section 文件。
      if (!this.track) this.track = this._createTrack();
      if (!this.track) return;

      this.video_containers = this.querySelectorAll(
        ".product-single__media-external-video--play"
      );

      this.refresh();
      this.setupEvents();
      this.setupProductGallery();
      this.preloadSlideImages();

      this._bindScroll();
      this._setIndex(0);
      // isReady 供 VariantSelects 判断元素是否已经接管（没有 track 时不接管）
      this.isReady = true;
      this.classList.add("is-ready");
    }

    /**
     * 给没有 track 的旧结构就地包一层滚动轨道。
     * 只挪动的直接子级 slides，箭头等其它兄弟节点位置不变。
     * @returns {HTMLElement|null}
     */
    _createTrack() {
      const slides = Array.from(this.children).filter((el) =>
        el.classList.contains("product-images__slide")
      );
      if (!slides.length) return null;

      const track = document.createElement("div");
      track.className = "product-images__track";
      this.insertBefore(track, slides[0]);
      slides.forEach((slide) => track.appendChild(slide));
      return track;
    }

    /**
     * 收集当前图库的 slides / thumbnails / 计数元素。
     * hide_variants 分支会改 slides 的类，所以 reInit 时要重新收集。
     */
    refresh() {
      this.hide_variants = this.dataset.hideVariants == "true";
      // slides 数量可能变，计数文案与缓存作废
      this._counterText = null;
      this._cachedVisibleSlides = null;

      this.slides = Array.from(
        this.querySelectorAll(".product-images__slide")
      );
      this.thumbnails = this.thumbnail_container
        ? Array.from(
            this.thumbnail_container.querySelectorAll(".product-thumbnail")
          )
        : [];
      this.prev_button = this.querySelector(".flickity-prev");
      this.next_button = this.querySelector(".flickity-next");
      // .mobile-item-number 是 <product-slider> 的兄弟节点
      this.mobile_item_number = this.parentElement
        ? this.parentElement.querySelector(".mobile-item-number")
        : null;
    }

    /**
     * 真正参与布局的 slides。
     * 优化：引入缓存机制，避免频繁读取 offsetWidth 触发剧烈的 Forced Reflow。
     */
    _visibleSlides() {
      if (!this._cachedVisibleSlides) {
        this._cachedVisibleSlides = this.slides.filter(
          (slide) => slide.offsetWidth > 0
        );
      }
      return this._cachedVisibleSlides;
    }

    _indexFromScroll() {
      const width = this.track.clientWidth;
      if (!width) return 0;
      return Math.round(this.track.scrollLeft / width);
    }

    /**
     * slides 都是 track 宽度的 100%（无 gap、无 margin），
     * 所以第 n 张的滚动位置就是 n * track.clientWidth。
     */
    _goTo(index, instant) {
      const slides = this._visibleSlides();
      if (!slides.length) return;
      const i = Math.max(0, Math.min(index, slides.length - 1));
      const left = i * this.track.clientWidth;

      // 平滑滚动期间抑制计数跟随：否则从第 1 张跳到第 N 张时数字会一路数过去。
      // 手指滑动不受影响（下面 pointerdown 会解除抑制）。
      this._suppressCounter = !instant;

      if (instant) {
        this.track.scrollLeft = left;
      } else {
        this.track.scrollTo({ left: left, behavior: "smooth" });
      }
      // 程序化选择立即落定状态（与 Flickity 的 select → change 一致），不等平滑滚动结束
      this._setIndex(i);
    }

    _bindScroll() {
      this.track.addEventListener("scroll", this._onScroll, { passive: true });
      // 用户一上手就解除抑制，手指拖动时计数立刻跟手
      this.track.addEventListener(
        "pointerdown",
        () => {
          this._suppressCounter = false;
        },
        { passive: true }
      );
      if ("onscrollend" in window) {
        this.track.addEventListener("scrollend", this._onScrollEnd, {
          passive: true,
        });
      }
    }

    _onScroll() {
      if (!this._raf) {
        this._raf = requestAnimationFrame(() => {
          this._raf = 0;
          const slides = this._visibleSlides();
          if (!slides.length) return;
          const i = Math.max(
            0,
            Math.min(this._indexFromScroll(), slides.length - 1)
          );
          this.selectedIndex = i;
          // 计数是位置指示器，滚动过程中要跟手更新。
          // .is-selected / 缩略图 / 暂停视频这类重活仍等滚动结束再落定：
          // 否则跨多张的平滑滚动会让放大镜按钮逐张闪现。
          if (!this._suppressCounter) this._updateCounter(i, slides.length);
        });
      }
      // scrollend 兼容兜底（Safari < 17）
      if (!("onscrollend" in window)) {
        clearTimeout(this._settleTimer);
        this._settleTimer = setTimeout(this._onScrollEnd, 120);
      }
    }

    _onScrollEnd() {
      this._suppressCounter = false;
      this._setIndex(this._indexFromScroll());
    }

    /** 移动端 "i / N"，只在文案变化时写 DOM */
    _updateCounter(index, total) {
      if (!this.mobile_item_number) return;
      const text = `${index + 1} / ${total}`;
      if (this._counterText === text) return;
      this._counterText = text;
      this.mobile_item_number.innerHTML = text;
    }

    /**
     * 把视觉状态落定到某一张。
     * @param {number} index 可见 slides 里的下标
     */
    _setIndex(index) {
      const slides = this._visibleSlides();
      if (!slides.length) return;

      const i = Math.max(0, Math.min(index, slides.length - 1));
      const current = slides[i];
      // 用「上次落定的元素」判断前一张，而不是按旧下标回查：
      // 变体 bundle 切换后同一位置（如第 1 张）的 slide 会换成另一个元素，
      // 按下标回查会取到新元素本身，误判为没换图，_syncThumbnails 被跳过，
      // 缩略图选中态就不更新。
      const previous = this._lastSyncedSlide;

      // 放大镜按钮靠 .is-selected 显示
      // （product.css / product-l1800.css / featured-product.css / section 内联样式）
      slides.forEach((slide) =>
        slide.classList.toggle("is-selected", slide === current)
      );

      this._updateCounter(i, slides.length);

      if (current !== previous) {
        if (previous) this._pauseMedia(previous);
        this._syncThumbnails(current);
      }
      this.selectedIndex = i;
      this._syncedIndex = i;
      this._lastSyncedSlide = current;
    }

    /** 切换走的那张如果正在播放视频，暂停它并恢复播放遮罩 */
    _pauseMedia(slide) {
      const media = slide.querySelector(".product-single__media");
      if (!media) return;

      if (media.classList.contains("product-single__media-external-video")) {
        const iframe = media.querySelector("iframe");
        if (iframe) {
          if (media.dataset.provider === "youtube") {
            iframe.contentWindow.postMessage(
              JSON.stringify({
                event: "command",
                func: "pauseVideo",
                args: "",
              }),
              "*"
            );
          } else if (media.dataset.provider === "vimeo") {
            iframe.contentWindow.postMessage(
              JSON.stringify({ method: "pause" }),
              "*"
            );
          }
        }
        const overlay = media.querySelector(
          ".product-single__media-external-video--play"
        );
        if (overlay) overlay.removeAttribute("hidden");
      } else if (
        media.classList.contains("product-single__media-native-video")
      ) {
        const video = media.querySelector("video");
        if (video) video.pause();
      }
    }

    /** 缩略图与 slides 共用 "{section.id}-{media.id}" 后缀，按 id 对齐最稳 */
    _mediaIdOf(element) {
      return element && element.id
        ? element.id.replace(/^(Slide|Thumb)-/, "")
        : "";
    }

    _syncThumbnails(currentSlide) {
      if (!this.thumbnails.length) return;

      const mediaId = this._mediaIdOf(currentSlide);
      let active = null;

      this.thumbnails.forEach((thumb) => {
        const isCurrent =
          mediaId !== "" && this._mediaIdOf(thumb) === mediaId;
        thumb.classList.toggle("is-initial-selected", isCurrent);
        if (isCurrent) active = thumb;
      });

      // 按 id 匹配不到（图库结构异常）时保留原选中态，
      // 避免把缩略图高亮全部清掉
      if (!active) return;

      // 滚动过程中会反复调用，只有真正换图时才滚动缩略图容器
      if (this._activeThumb === active) return;
      this._activeThumb = active;

      requestAnimationFrame(() => {
        if (!active || active.offsetParent === null) return;
        const parent = active.parentElement;
        parent.scrollTo({
          left:
            active.offsetLeft -
            parent.clientWidth / 2 +
            active.clientWidth / 2,
          top:
            active.offsetTop -
            parent.clientHeight / 2 +
            active.clientHeight / 2,
          behavior: "auto",
        });
      });
    }

    /**
     * 媒体集合被外部改动（变体切换 + hide_variants）后重新对齐。
     * 不再销毁重建：布局由 CSS 负责，这里只需重新收集并同步状态。
     */
    reInit() {
      if (!this.track) return;
      this.refresh();
      this._activeThumb = null;
      this._setIndex(this._indexFromScroll());
    }

    // 预加载滑块图片，避免切换时空白
    preloadSlideImages() {
      // 隐藏图库（如 Features/Video 页签）显示后再加载
      if (this.offsetParent === null) {
        return;
      }
      const slides = this._visibleSlides();
      // 只预载「当前 + 下一张」。其余交给 lazysizes 按滚动位置加载：
      // 一次性拉多张大图会和 LCP 首图抢带宽，反而拖慢 LCP。
      [slides[this.selectedIndex], slides[this.selectedIndex + 1]]
        .filter(Boolean)
        .forEach((slide) => {
          slide
            .querySelectorAll("img.lazyload[data-src]")
            .forEach((img) => this._unveil(img));
        });
    }

    _unveil(img) {
      // 优先交给 lazysizes：它会先把 sizes="auto" 算成真实宽度，
      // 浏览器才会选对档位；否则 sizes="auto" 非法会回退 100vw 拉到 1220w。
      if (
        window.lazySizes &&
        lazySizes.loader &&
        typeof lazySizes.loader.unveil === "function"
      ) {
        lazySizes.loader.unveil(img);
        return;
      }
      // 兜底：手动提升，必须显式写死 sizes
      if (img.dataset.src && !img.getAttribute("src")) {
        img.src = img.dataset.src;
      }
      if (img.dataset.srcset && !img.getAttribute("srcset")) {
        img.srcset = img.dataset.srcset;
      }
      if (!img.getAttribute("sizes")) {
        img.setAttribute("sizes", "(min-width: 768px) 640px, 100vw");
      }
      if (img.parentElement) {
        img.parentElement
          .querySelectorAll("source[data-srcset]")
          .forEach((source) => {
            if (source.dataset.srcset && !source.getAttribute("srcset")) {
              source.srcset = source.dataset.srcset;
            }
            if (source.dataset.sizes && !source.getAttribute("sizes")) {
              source.sizes =
                source.dataset.sizes === "auto"
                  ? "(min-width: 768px) 640px, 100vw"
                  : source.dataset.sizes;
            }
          });
      }
      img.classList.remove("lazyload", "lazyloading");
      img.classList.add("lazyloaded", "no-blur");
    }

    /**
     * 优化：改用事件委托（Event Delegation），保证即便重复初始化，事件监听器也只挂载一次。
     */
    setupEvents() {
      if (this._eventsBound) return;
      this._eventsBound = true;

      // 1. 缩略图点击代理（挂载在缩略图容器或 DOM 上）
      if (this.thumbnail_container) {
        this.thumbnail_container.addEventListener("click", (e) => {
          const thumb = e.target.closest(".product-thumbnail");
          if (thumb) this.thumbnailClick(thumb);
        });
      }

      // 2. 左右方向箭头点击/按键代理
      this.addEventListener("click", (e) => {
        if (e.target.closest(".flickity-prev")) this._step(-1);
        if (e.target.closest(".flickity-next")) this._step(1);
      });

      this.addEventListener("keyup", (e) => {
        const prevBtn = e.target.closest(".flickity-prev");
        const nextBtn = e.target.closest(".flickity-next");
        if (prevBtn || nextBtn) {
          this._step(prevBtn ? -1 : 1);
          e.preventDefault();
        }
      });

      // 3. 视频播放按钮代理
      this.addEventListener("click", (e) => {
        const btn = e.target.closest(
          ".product-single__media-external-video--play button"
        );
        if (btn) {
          const overlay = btn.closest(
            ".product-single__media-external-video--play"
          );
          if (overlay) overlay.setAttribute("hidden", "");
        }
      });

      // 4. 全局键盘左右键代理（兼顾 accessibility）
      this.setAttribute("tabindex", "0");
      this.addEventListener("keydown", (event) => {
        // 避让：焦点在输入框/选择框内时不响应切图
        if (
          ["INPUT", "TEXTAREA", "SELECT"].includes(event.target.tagName)
        ) {
          return;
        }
        // 避让：焦点在导航按钮上时交由按钮 handler 响应
        if (event.target.closest && event.target.closest(".flickity-nav")) {
          return;
        }

        const slides = this._visibleSlides();
        if (slides.length < 2) return;

        if (event.key === "ArrowLeft") {
          this._step(-1);
          event.preventDefault();
        } else if (event.key === "ArrowRight") {
          this._step(1);
          event.preventDefault();
        }
      });
    }

    /** 箭头翻页，首尾循环（对应原来的 wrapAround: true） */
    _step(delta) {
      const slides = this._visibleSlides();
      if (slides.length < 2) return;
      // 以「上次落定」的下标为基准（同 Flickity 的 selectedIndex 只在 settle 时更新），
      // 这样平滑滚动途中连点箭头也能每次稳定前进一张
      const base = Math.min(this._syncedIndex, slides.length - 1);
      this._goTo((base + delta + slides.length) % slides.length);
    }

    thumbnailClick(thumbnail) {
      const mediaId = this._mediaIdOf(thumbnail);
      if (!mediaId) return;
      this.selectCell(`#Slide-${mediaId}`);
    }

    setDraggable(draggable) {
      // 3D 模型打开时禁掉横向滚动，避免模型拖拽和轮播抢手势
      if (!this.track) return;
      this.track.style.overflowX = draggable ? "" : "hidden";
    }

    selectCell(mediaId, isInstant) {
      // selectCell / reInit 是原型方法，元素即使没接管（没有 track）也存在，
      // 所以这里必须自己判空，否则变体切换会在这里抛错并中断价格/按钮更新
      if (!this.track) return;
      const slide = this.querySelector(mediaId);
      if (!slide) return;

      // 容器尚未布局（未显示的页签 / quick-view 抽屉）时 clientWidth 为 0，
      // 算不出滚动位置，等下一帧重试
      const attempt = (retries) => {
        if (!this.track.clientWidth) {
          if (retries > 0) requestAnimationFrame(() => attempt(retries - 1));
          return;
        }
        const index = this._visibleSlides().indexOf(slide);
        if (index < 0) return;
        // 变体切换时瞬间定位，避免长距离滑动动画
        this._goTo(index, !!isInstant);
      };
      attempt(10);
    }

    setupProductGallery() {
      // setEventListeners 不幂等（会重复绑定 zoom 点击），只跑一次
      if (this._galleryReady) return;
      if (!this.querySelectorAll(".product-single__media-zoom").length) {
        return;
      }
      this._galleryReady = true;
      this.setEventListeners();
    }

    buildItems() {
      // PhotoSwipe 只应包含实际可见的 slide：
      // - hide_variants 时其他分组的 slide 已不带 is-active，自然被排除；
      // - 变体图库（data-variant-gallery）里其他 bundle 的首图由纯 CSS 隐藏
      //   （.product-images__slide-item--variant:not(.is-current-variant){display:none}），
      //   但它们 class 里仍带 is-active，只按 class 收集会把这些隐藏图带进放大预览。
      this.activeImages = Array.from(
        this.querySelectorAll(
          ".product-images__slide.is-active .product-single__media-image"
        )
      ).filter((item) => {
        const slide = item.closest(".product-images__slide");
        if (
          slide &&
          slide.classList.contains("product-images__slide-item--variant") &&
          !slide.classList.contains("is-current-variant") &&
          slide.closest("[data-variant-gallery]")
        ) {
          return false;
        }
        return true;
      });

      return this.activeImages.map((item, pswpIndex) => {
        let index = [].indexOf.call(
          item.parentNode.parentNode.children,
          item.parentNode
        );

        let activelink = item.querySelector(".product-single__media-zoom");

        activelink.dataset.index = index;
        // 过滤掉 CSS 隐藏的 slide 后，DOM 序号不再等于 items 下标，
        // 记录真实下标供 zoomClick 定位，避免打开错位
        activelink.dataset.pswpIndex = pswpIndex;
        return {
          src: activelink.getAttribute("href"),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
        };
      });
    }

    setEventListeners() {
      const productSingleMediaObject = this.querySelectorAll(
        ".product-single__media"
      );
      let offsetValue = 0;
      this.links = [];
      for (let i = 0; i < productSingleMediaObject.length; i++) {
        let o = productSingleMediaObject[i];
        let possibleZoomLink = o.children[0];
        if (
          possibleZoomLink.classList.contains("product-single__media-zoom")
        ) {
          Object.defineProperty(possibleZoomLink, "zoomObjectOffset", {
            value: offsetValue,
            // 变体首图会被挪到第 1 张，届时需要把它的偏移改成 0
            writable: true,
          });
          this.links.push(possibleZoomLink);
        } else {
          offsetValue++;
        }
      }
      this.pswpElement = document.querySelectorAll(".pswp")[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail =
            (this._zoomOrigin &&
              this._zoomOrigin.closest(".product-images__slide")) ||
            this.querySelector(".product-images__slide.is-selected") ||
            this.querySelector(".product-images__slide.is-active");
          if (!thumbnail) {
            return { x: 0, y: 0, w: 1 };
          }
          const pageYScroll =
            window.pageYOffset || document.documentElement.scrollTop;
          const rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width,
          };
        },
      };

      this.links.forEach((link) => {
        link.addEventListener("click", (e) => this.zoomClick(e, link));
      });
    }

    zoomClick(e, link) {
      this.items = this.buildItems();
      this._zoomOrigin = link;
      // 优先用 buildItems 记录的 items 真实下标（已过滤 CSS 隐藏图）；
      // 无则回退到旧的 DOM 序号减 offset 算法
      this.pswpOptions.index =
        link.dataset.pswpIndex != null
          ? parseInt(link.dataset.pswpIndex, 10)
          : parseInt(link.dataset.index - link["zoomObjectOffset"], 10);
      if (typeof PhotoSwipe !== "undefined") {
        let pswp = new PhotoSwipe(
          this.pswpElement,
          PhotoSwipeUI_Default,
          this.items,
          this.pswpOptions
        );
        pswp.listen("firstUpdate", function () {
          pswp.listen("parseVerticalMargin", function (item) {
            item.vGap = {
              top: 50,
              bottom: 50,
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define("product-slider", ProductSlider);
}


/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.sticky = this.dataset.sticky;
        this.form = document.getElementById(
          `product-form-${this.dataset.section}`
        );
        this.form.querySelector("[name=id]").disabled = false;
        if (!this.sticky) {
          // 同一 section 里可能有多个 <product-form>（如吸底购买栏）指向同一个
          // 表单 id：只让第一个绑定 submit。否则一次点击会发两次 /cart/add，
          // 购物车数量翻倍。
          if (!this.form.dataset.productFormBound) {
            this.form.dataset.productFormBound = "true";
            this.form.addEventListener(
              "submit",
              this.onSubmitHandler.bind(this)
            );
          }
        }
        this.cartNotification = document.querySelector("cart-notification");
        this.body = document.body;

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.form.reportValidity()) {
          return;
        }

        const submitButtons = document.querySelectorAll(
          ".single-add-to-cart-button"
        );

        submitButtons.forEach((submitButton) => {
          if (submitButton.classList.contains("loading")) return;
          submitButton.setAttribute("aria-disabled", true);
          submitButton.classList.add("loading");
        });

        this.handleErrorMessage();

        const config = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
        };

        let formData = new FormData(this.form);

        formData.append(
          "sections",
          this.getSectionsToRender().map((section) => section.section)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {

            if (response.status) {
             
            
              dispatchCustomEvent("product:variant-error", {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
            
          
              
              this.handleErrorMessage(response.description);
              return;
            }

            this.renderContents(response);

            dispatchCustomEvent("cart:item-added", {
              product: response.hasOwnProperty("items")
                ? response.items[0]
                : response,
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButtons.forEach((submitButton) => {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("aria-disabled");
            });
          });
      }

      getSectionsToRender() {
        return [
          {
            id: "Cart",
            section: "main-cart",
            selector: ".thb-cart-form",
          },
          {
            id: "Cart-Drawer",
            section: "cart-drawer",
            selector: ".cart-drawer",
          },
          {
            id: "cart-drawer-toggle",
            section: "cart-bubble",
            selector: ".thb-item-count",
          },
        ];
      }
      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          if (!document.getElementById(section.id)) {
            return;
          }
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );

          if (typeof Cart !== "undefined") {
            new Cart().renderContents(parsedState);
          }
        });
        // 所有 section 替换完后再初始化一次；放在循环里会按 section 数量
        // 重复 new CartDrawer()，重复绑定 .remove 点击（一次删除发多个请求）
        if (typeof CartDrawer !== "undefined") {
          new CartDrawer();
        }

        let product_drawer = document.getElementById("Product-Drawer"),
          search_drawer = document.getElementById("Search-Drawer");

        if (search_drawer.classList.contains("active")) {
          search_drawer.classList.remove("active");
        }
        if (product_drawer && product_drawer.contains(this)) {
          product_drawer.classList.remove("active");
          this.body.classList.remove("open-cc--product");
          if (document.getElementById("Cart-Drawer")) {
            this.body.classList.add("open-cc");
            document.getElementById("Cart-Drawer").classList.add("active");
          }
        } else if (document.getElementById("Cart-Drawer")) {
          this.body.classList.add("open-cc");
          document.getElementById("Cart-Drawer").classList.add("active");
          dispatchCustomEvent("cart-drawer:open");
        }
      }
      getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
// 检查是否已经注册了名为"product-add-to-cart-sticky"的自定义元素，避免重复注册
if (!customElements.get("product-add-to-cart-sticky")) {
  // 定义ProductAddToCartSticky类，继承自HTMLElement
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
      // 获取当前页面产品价格的文本内容（用于后续显示或调试）
      this.selectedText = document.querySelector(
        ".thb-product-detail .product-information ins .money"
      )?.innerText;
      // 判断是否启用动画（依赖body上的class和gsap库是否存在）
      this.animations_enabled =
        document.body.classList.contains("animations-true") &&
        typeof gsap !== "undefined";
      console.log("初始化this.selectedText==", this.selectedText);
    }
    // 当元素插入DOM时自动调用
    connectedCallback() {
      this.setupObservers(); // 设置可见性观察器
      this.setupToggle(); // 设置展开/收起切换逻辑
    }
    // 设置展开/收起切换逻辑
    setupToggle() {
      // 获取展开按钮和内容区域
      const button = this.querySelector(".product-add-to-cart-sticky--inner"),
        content = this.querySelector(".product-add-to-cart-sticky--content");

      // 如果启用动画，使用gsap实现动画效果
      if (this.animations_enabled) {
        // 创建gsap时间线，初始为反向暂停状态
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            // 动画开始时，给按钮加上sticky-open样式
            button.classList.add("sticky-open");
          },
          onReverseComplete: () => {
            // 动画反向结束时，移除sticky-open样式
            button.classList.remove("sticky-open");
          },
        });

        // 设置内容区域初始状态为可见且高度自适应
        tl.set(
          content,
          {
            display: "block",
            height: "auto",
          },
          "start"
        ).from(
          content,
          {
            height: 0, // 动画从高度0开始
            duration: 0.25, // 动画时长0.25秒
          },
          "start+=0.001"
        );

        // 点击按钮时，切换动画的正向/反向播放，实现展开/收起
        button.addEventListener("click", function () {
          tl.reversed() ? tl.play() : tl.reverse();
          return false; // 阻止默认行为
        });
      } else {
        // 如果未启用动画，直接切换active样式
        // button.addEventListener("click", function () {
        //   content.classList.toggle("active");
        //   return false; // 阻止默认行为
        // });
      }
    }
    // 设置IntersectionObserver，监听表单和footer的可见性，控制吸底条的显示与隐藏
    setupObservers() {
      let _this = this,
        // 创建IntersectionObserver实例，监听目标元素的可见性变化
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach((entry) => {
              // 监听footer元素
              if (entry.target === footer) {
                if (entry.intersectionRatio > 0) {
                  // footer可见时，隐藏吸底条
                  _this.classList.remove("sticky--visible");
                } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                  // footer不可见且表单已滚动通过，显示吸底条
                  _this.classList.add("sticky--visible");
                  console.log("this.selectedText1===", this.selectedText);
                }
              }
              // 监听产品表单元素
              if (entry.target === form) {
                let boundingRect = form.getBoundingClientRect();

                // 当表单不可见且页面已滚动超过表单底部，显示吸底条
                if (
                  entry.intersectionRatio === 0 &&
                  window.scrollY > boundingRect.top + boundingRect.height
                ) {
                  _this.formPassed = true;
                  _this.classList.add("sticky--visible");
                  console.log("this.selectedText2===", this.selectedText);
                } else if (entry.intersectionRatio === 1) {
                  // 表单完全可见时，隐藏吸底条
                  _this.formPassed = false;
                  _this.classList.remove("sticky--visible");
                }
              }
            });
          },
          {
            threshold: [0, 1], // 仅在完全不可见或完全可见时触发
          }
        ),
        // 获取产品表单和footer元素
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById("footer");
      _this.formPassed = false; // 标记表单是否已滚动通过
      observer.observe(form); // 监听表单
      observer.observe(footer); // 监听footer
    }
  }

  // 注册自定义元素
  customElements.define("product-add-to-cart-sticky", ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get("side-panel-links")) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll("button");
      this.drawer = document.getElementById("Product-Information-Drawer");
      this.buttons = this.drawer.querySelector(".side-panel-content--tabs");
      this.panels = this.drawer
        .querySelector(".side-panel-content--inner")
        .querySelectorAll(".side-panel-content--tab-panel");
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {}
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener("click", (e) => {
          this.body.classList.add("open-cc");
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add("active");
        });
      });
    }
  }

  customElements.define("side-panel-links", ProductSidePanelLinks);
}
